import * as React from 'react'

import { Chevron } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'

import { observer } from 'mobx-react'

import PlusMinus from 'modules/core/components/PlusMinus'

import styles from './index.module.scss'

const cx = classNames.bind(styles)
type Type = 'primary' | 'brand'
type Size = 'normal' | 'small'
type IconType = 'chevron' | 'plus-minus' | 'none'
interface Props {
  opened: boolean
  type?: Type
  size?: Size
  renderHeader?: () => JSX.Element
  renderCollectionHeader?: () => JSX.Element
  toggle: React.MouseEventHandler<HTMLDivElement>
  expandIcon?: IconType
  bottomRadius?: boolean
  headerRounded?: boolean
  headerBorders?: boolean
  dropDownAnimated?: boolean
  scrollLimited?: boolean
  fromCollection?: boolean
  caps?: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const ExplotableItem = ({
  children,
  opened,
  renderHeader = () => <></>,
  renderCollectionHeader = () => <></>,
  toggle,
  expandIcon = 'chevron',
  type = 'primary',
  size = 'normal',
  dropDownAnimated = false,
  bottomRadius = true,
  headerBorders = true,
  scrollLimited = true,
  headerRounded = true,
  fromCollection = false,
  caps = true,
  onMouseEnter,
  onMouseLeave,
}: React.PropsWithChildren<Props>) => {
  return (
    <li
      className={cx('expandableItem', type, size, {
        opened,
      })}
    >
      {fromCollection ? (
        <div onClick={toggle}>{renderCollectionHeader()}</div>
      ) : (
        <div
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          className={cx('header', {
            bottomRadius,
            headerBorders,
            headerRounded,
            caps,
          })}
          onClick={toggle}
        >
          <div className={styles.content}>{renderHeader()}</div>
          <div className={styles.icon}>{renderExpandIcon(expandIcon, opened)}</div>
        </div>
      )}
      <div
        className={cx('dropdown', {
          dropDownAnimated,
          opened,
          scrollLimited,
        })}
      >
        {children}
      </div>
    </li>
  )
}

function renderExpandIcon(type: IconType, opened: boolean): JSX.Element {
  switch (type) {
    case 'chevron':
      return <Chevron direction={opened ? 'up' : 'down'} type="terciary" />
    case 'plus-minus':
      return <PlusMinus opened={opened} />
    case 'none':
      return <></>
  }
}

export default observer(ExplotableItem)
